import { useEffect } from "react";
import { MotifIcon } from "@ey-xd/motif-react";
import { IconoirWarningTriangle } from "@ey-xd/motif-icon";
import "./MaintanceWindow.scss";
import { getMaintenanceWindowData } from "../../store/slices/MaintenanceWindowSlice";
import { useLocation } from "react-router";
import { AppDispatch, RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";

const MaintenanceWindow = () => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();

  // dispatch the call to fetch maintenance window data on change of the location
  useEffect(() => {
    dispatch(getMaintenanceWindowData());
  }, [dispatch, location]);

  const maintenanceWindowData = useSelector(
    (state: RootState) => state.MaintenanceWindowSlice.data,
  );

  if (maintenanceWindowData?.IsEnabled) {
    return (
      <section className="maintenance-window" aria-label="Maintenance window">
        <div className="maintenance-window__content">
          <div className="maintenance-window__icon" aria-hidden="true">
            <MotifIcon src={IconoirWarningTriangle} size="20" fill="#D07200" />
          </div>
          <p className="maintenance-window__message">
            {maintenanceWindowData.TextMessage}
            {maintenanceWindowData.LinkUrl &&
              maintenanceWindowData.LinkLabel && (
                <a
                  className="maintenance-window__link"
                  href={maintenanceWindowData.LinkUrl}
                  target="_blank"
                >
                  {" "}
                  {maintenanceWindowData.LinkLabel}
                </a>
              )}
          </p>
        </div>
      </section>
    );
  } else {
    return null;
  }
};

export default MaintenanceWindow;
